import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { text: String, id: String }

  copy() {
    App.executeCopy(this.textValue, this.idValue)
    App.displayFlash("success", i18n.t("js.copied"))
  }
}
